<script setup lang="ts" generic="Value extends unknown">
import type { FormField } from '@shared/common/form/domain/form/field/base.form-field';

defineModel<FormField<Value>>({ required: true });
</script>

<template>
  <div></div>
</template>
